// A labelled one-line input, for the pages the admin edits in place.
export function Field({
  label,
  value,
  onChange,
  placeholder,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <label className="block">
      <span className="mb-0.5 block font-sans text-[11px] tracking-[0.06em] text-ink-3 uppercase">{label}</span>
      <input
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded border border-rule bg-paper px-2 py-1 font-sans text-[13px] text-ink placeholder:text-ink-3 focus:border-accent focus-visible:outline-none"
      />
    </label>
  );
}
